import { YourIR } from 'yourir-next';

export default function AsxAnnouncementsArchive(props)
{
    const { className, startYear, order } = props;

    let itemContent = [];

    const currentYear = new Date().getFullYear();

    for (let i = startYear ; i <= currentYear; i++)
    {
        itemContent[i] = (
            <div key={ i } data-yourir={ "announcements year='" + i + "' onePage='1'"}>
                <details data-yourir="ifnot isEmpty" className="yourir-hide-template bg-white cursor-pointer mb-20 rounded rounded-lg overflow-hidden border-b border-l border-r border-grey-2" open={ (order != "asc" ? i == currentYear : i == startYear  ) }>
                    <summary className="block bg-bb hover:bg-bb/80 text-white p-30 sol-asx-announcement-detail-dark">
                        Announcements { i }
                    </summary>
                    <div data-yourir="items">
                        <a className="flex items-center p-30 group even:bg-grey no-underline sm:items-center yourir-open-in-new-window" title="click to view PDF">
                            <span className="inline-block relative shrink-0">
                                <svg width="32" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.47 24.19">
                                    <path d="M7.94,2.42a.36.36,0,0,0-.28.12.38.38,0,0,0-.12.28V21.37a.4.4,0,0,0,.4.4H21.65a.36.36,0,0,0,.28-.12.38.38,0,0,0,.12-.28V9.68H17.62A2.82,2.82,0,0,1,14.8,6.85V2.42Zm9.27.9V6.85a.41.41,0,0,0,.41.41h3.53ZM5.12,2.82A2.82,2.82,0,0,1,7.94,0h8.2a2.83,2.83,0,0,1,2,.83l5.5,5.5a2.83,2.83,0,0,1,.83,2v13a2.83,2.83,0,0,1-2.82,2.82H7.94a2.83,2.83,0,0,1-2.82-2.82Z" style={{"fill":"#000000","fillOpacity":"0.5","fillRule":"evenodd"}}/>
                                    <rect y="4.38" width="13.55" height="6.72" rx="0.88" style={{"fill": "#A40037"}}/>
                                    <path d="M3.27,8.25h-.9V7.68h.9a.82.82,0,0,0,.34-.07.41.41,0,0,0,.19-.2.61.61,0,0,0,.06-.28.72.72,0,0,0-.06-.29.5.5,0,0,0-.19-.22.68.68,0,0,0-.34-.08H2.62v3H1.89V6H3.27A1.55,1.55,0,0,1,4,6.12a1.08,1.08,0,0,1,.62,1,1,1,0,0,1-.16.59A1,1,0,0,1,4,8.11,1.7,1.7,0,0,1,3.27,8.25ZM6.69,9.51H5.92V8.94h.77a.82.82,0,0,0,.48-.13.72.72,0,0,0,.3-.38,1.59,1.59,0,0,0,.1-.61V7.65a2.28,2.28,0,0,0-.05-.48,1.14,1.14,0,0,0-.17-.35.83.83,0,0,0-.28-.21.87.87,0,0,0-.37-.07H5.9V6h.8a1.75,1.75,0,0,1,.65.12,1.39,1.39,0,0,1,.51.34A1.36,1.36,0,0,1,8.19,7a1.85,1.85,0,0,1,.12.69v.16a1.92,1.92,0,0,1-.12.69,1.36,1.36,0,0,1-.33.54,1.39,1.39,0,0,1-.51.34A1.76,1.76,0,0,1,6.69,9.51ZM6.33,6V9.51H5.6V6Zm4,0V9.51H9.58V6Zm1.41,1.51v.57H10.11V7.48ZM11.89,6v.57H10.11V6Z" style={{"fill":"#fff"}}/>
                                </svg>
                            </span>
                            <p className="px-30">
                                <span className="text-black/50 text-sm whitespace-nowrap " data-yourir="$cur.date format='DD-MMM-YYYY'"></span>
                                <br />
                                <span className="text-bb group-hover:underline" data-yourir="$cur.headingText"></span>
                            </p>
                        </a>
                    </div>
                </details>
            </div>
        );
    };

    return (
        <div className={ "text-left" + (className ? " " + className : "") }>
            <YourIR>
                { ( order != "asc" ? itemContent.reverse() : itemContent) }
            </YourIR>
        </div>
    );
}
